<template>
    <v-container fluid class="pa-6">
        <!-- Header Principal -->
        <div class="d-flex align-center mb-6">
           

            <v-avatar size="48" color="primary" class="mr-4">
                <v-icon color="white" size="28">mdi-account-multiple</v-icon>
            </v-avatar>
            <div class="flex-grow-1">
                <h1 class="text-h4 font-weight-bold text-primary">Usuários Logados</h1>
                <p class="text-subtitle-1 text-grey-darken-1 mb-0">
                    Monitore e gerencie sessões ativas do sistema
                </p>
            </div>


             

            
            <!-- ✅ BOTÕES DE AÇÃO -->
            <v-btn @click="atualizarDados" color="primary" variant="elevated" :loading="carregando" size="large"
                class="mr-2">
                <v-icon start>mdi-refresh</v-icon>
                Atualizar
            </v-btn>

            <v-btn @click="limparTokensExpirados" color="warning" variant="elevated" :loading="carregando" size="large">
                <v-icon start>mdi-delete-sweep</v-icon>
                Limpar Expirados
            </v-btn>

            <!-- ✅ BOTÃO VOLTAR PRIMEIRO -->
            <v-btn @click="voltarMenuPrincipal" color="grey-darken-1" variant="outlined" class="ml-4 "
                :loading="navegando">
                <v-icon start>mdi-arrow-left</v-icon>
                Voltar ao Menu
            </v-btn>
        </div>

        <!-- Cards de Estatísticas -->
        <v-row class="mb-6">
            <v-col cols="12" md="3">
                <v-card class="stats-card" color="primary" variant="tonal" elevation="2">
                    <v-card-text class="text-center pa-4">
                        <v-avatar size="56" color="primary" class="mb-3">
                            <v-icon color="white" size="32">mdi-account-check</v-icon>
                        </v-avatar>
                        <div class="text-h3 font-weight-bold text-primary">
                            {{ estatisticas?.usuarios_unicos_logados || 0 }}
                        </div>
                        <div class="text-subtitle-1 text-primary">Usuários Únicos</div>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col cols="12" md="3">
                <v-card class="stats-card" color="success" variant="tonal" elevation="2">
                    <v-card-text class="text-center pa-4">
                        <v-avatar size="56" color="success" class="mb-3">
                            <v-icon color="white" size="32">mdi-key</v-icon>
                        </v-avatar>
                        <div class="text-h3 font-weight-bold text-success">
                            {{ estatisticas?.total_tokens || 0 }}
                        </div>
                        <div class="text-subtitle-1 text-success">Tokens Ativos</div>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col cols="12" md="3">
                <v-card class="stats-card" color="info" variant="tonal" elevation="2">
                    <v-card-text class="text-center pa-4">
                        <v-avatar size="56" color="info" class="mb-3">
                            <v-icon color="white" size="32">mdi-circle</v-icon>
                        </v-avatar>
                        <div class="text-h3 font-weight-bold text-info">
                            {{ estatisticas?.usuarios_online || 0 }}
                        </div>
                        <div class="text-subtitle-1 text-info">Online (5min)</div>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col cols="12" md="3">
                <v-card class="stats-card" color="warning" variant="tonal" elevation="2">
                    <v-card-text class="text-center pa-4">
                        <v-avatar size="56" color="warning" class="mb-3">
                            <v-icon color="white" size="32">mdi-login</v-icon>
                        </v-avatar>
                        <div class="text-h3 font-weight-bold text-warning">
                            {{ estatisticas?.tokens_hoje || 0 }}
                        </div>
                        <div class="text-subtitle-1 text-warning">Logins Hoje</div>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <!-- Tabela Principal -->
        <v-card elevation="4" class="main-table-card">
            <v-card-title class="d-flex align-center pa-4 bg-grey-lighten-4">
                <v-icon class="mr-2" color="primary">mdi-table</v-icon>
                <span class="text-h6 font-weight-bold">Sessões Ativas</span>
                <v-spacer></v-spacer>
                <v-chip :color="usuariosLogados.length > 0 ? 'success' : 'grey'" variant="elevated">
                    {{ usuariosLogados.length }} usuário{{ usuariosLogados.length !== 1 ? 's' : '' }}
                </v-chip>
            </v-card-title>

            <v-divider></v-divider>

            <v-card-text class="pa-0">
                <v-data-table :headers="headers" :items="usuariosLogados" :loading="carregando" class="elevation-0"
                    :items-per-page="10" :items-per-page-options="[5, 10, 25, 50]"
                    loading-text="Carregando dados dos usuários..." no-data-text="Nenhum usuário logado encontrado">
                    <!-- Status -->
                    <template v-slot:item.status="{ item }">
                        <v-chip :color="getStatusColor(item.status)" size="small" variant="elevated"
                            class="font-weight-bold">
                            <v-icon start :icon="getStatusIcon(item.status)" size="16"></v-icon>
                            {{ getStatusText(item.status) }}
                        </v-chip>
                    </template>

                    <!-- Último acesso -->
                    <template v-slot:item.ultimo_acesso="{ item }">
                        <div v-if="item.ultimo_acesso">
                            <div class="text-body-2 font-weight-medium">
                                {{ formatarData(item.ultimo_acesso) }}
                            </div>
                            <div class="text-caption text-grey">
                                {{ formatarTempoRelativo(item.ultimo_acesso) }}
                            </div>
                        </div>
                        <v-chip v-else color="grey" size="small" variant="tonal">
                            <v-icon start size="14">mdi-help-circle</v-icon>
                            Nunca usado
                        </v-chip>
                    </template>

                    <!-- Tokens -->
                    <template v-slot:item.total_tokens="{ item }">
                        <v-chip color="info" size="small" variant="elevated" @click="verDetalhesTokens(item)"
                            class="cursor-pointer">
                            <v-icon start size="14">mdi-key-variant</v-icon>
                            {{ item.total_tokens }}
                        </v-chip>
                    </template>

                    <!-- Usuário ativo -->
                    <template v-slot:item.ativo="{ item }">
                        <v-chip :color="item.ativo === 'Sim' ? 'success' : 'error'" size="small" variant="elevated"
                            class="font-weight-bold">
                            <v-icon start :icon="item.ativo === 'Sim' ? 'mdi-check-circle' : 'mdi-close-circle'"
                                size="14"></v-icon>
                            {{ item.ativo }}
                        </v-chip>
                    </template>

                    <!-- Role -->
                    <template v-slot:item.role="{ item }">
                        <v-chip :color="getRoleColor(item.role)" size="small" variant="tonal">
                            {{ item.role || 'N/A' }}
                        </v-chip>
                    </template>

                    <!-- Ações -->
                    <template v-slot:item.actions="{ item }">
                        <div class="d-flex gap-2">
                            <v-btn @click="verDetalhes(item)" color="info" size="small" variant="elevated"
                                density="comfortable">
                                <v-icon size="16">mdi-eye</v-icon>
                                <v-tooltip activator="parent" location="top">
                                    Ver detalhes
                                </v-tooltip>
                            </v-btn>

                            <v-btn @click="revogarTodosTokens(item)" color="warning" size="small" variant="elevated"
                                density="comfortable" :loading="revogando === item.id">
                                <v-icon size="16">mdi-logout-variant</v-icon>
                                <v-tooltip activator="parent" location="top">
                                    Deslogar usuário
                                </v-tooltip>
                            </v-btn>
                        </div>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>

        <!-- Modal de Confirmação -->
        <v-dialog v-model="modalConfirmacao" max-width="500" persistent>
            <v-card class="confirmation-modal">
                <v-card-title class="d-flex align-center pa-4 bg-warning-lighten-4">
                    <v-icon color="warning" class="mr-2" size="28">mdi-alert</v-icon>
                    <span class="text-h6 font-weight-bold">Confirmar Deslogamento</span>
                </v-card-title>

                <v-divider></v-divider>

                <v-card-text class="pa-6">
                    <div class="text-center mb-4">
                        <v-avatar size="64" color="warning" variant="tonal" class="mb-3">
                            <v-icon size="32" color="warning">mdi-account-alert</v-icon>
                        </v-avatar>
                    </div>

                    <p class="text-body-1 text-center mb-3">
                        Tem certeza que deseja deslogar o usuário
                        <strong class="text-primary">{{ usuarioSelecionado?.nome }}</strong>?
                    </p>

                    <v-alert type="warning" variant="tonal" class="mb-0" density="compact">
                        <v-icon slot="prepend">mdi-information</v-icon>
                        Esta ação irá invalidar todos os <strong>{{ usuarioSelecionado?.total_tokens }}</strong>
                        tokens ativos e forçar um novo login em todos os dispositivos.
                    </v-alert>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions class="pa-4">
                    <v-spacer></v-spacer>
                    <v-btn @click="modalConfirmacao = false" variant="outlined" color="grey">
                        Cancelar
                    </v-btn>
                    <v-btn @click="confirmarRevogacao" color="warning" variant="elevated" :loading="revogando">
                        <v-icon start>mdi-logout-variant</v-icon>
                        Deslogar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Modal de Detalhes -->
        <v-dialog v-model="modalDetalhes" max-width="800" scrollable>
            <v-card v-if="usuarioSelecionado" class="details-modal">
                <v-card-title class="d-flex align-center pa-4 bg-info-lighten-4">
                    <v-icon class="mr-2" color="info" size="28">mdi-account-details</v-icon>
                    <span class="text-h6 font-weight-bold">Detalhes do Usuário</span>
                    <v-spacer></v-spacer>
                    <v-btn @click="modalDetalhes = false" icon variant="text" size="small">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-divider></v-divider>

                <v-card-text class="pa-6">
                    <v-row>
                        <!-- Informações do Usuário -->
                        <v-col cols="12" md="6">
                            <h3 class="text-h6 mb-3 text-primary">
                                <v-icon class="mr-2">mdi-account</v-icon>
                                Informações Pessoais
                            </h3>
                            <v-list density="compact" class="bg-grey-lighten-5 rounded">
                                <v-list-item>
                                    <v-list-item-title class="font-weight-medium">Login</v-list-item-title>
                                    <v-list-item-subtitle class="text-primary font-weight-bold">
                                        {{ usuarioSelecionado.login }}
                                    </v-list-item-subtitle>
                                </v-list-item>
                                <v-divider></v-divider>
                                <v-list-item>
                                    <v-list-item-title class="font-weight-medium">Nome</v-list-item-title>
                                    <v-list-item-subtitle>{{ usuarioSelecionado.nome }}</v-list-item-subtitle>
                                </v-list-item>
                                <v-divider></v-divider>
                                <v-list-item>
                                    <v-list-item-title class="font-weight-medium">Email</v-list-item-title>
                                    <v-list-item-subtitle>{{ usuarioSelecionado.email }}</v-list-item-subtitle>
                                </v-list-item>
                                <v-divider></v-divider>
                                <v-list-item>
                                    <v-list-item-title class="font-weight-medium">Role</v-list-item-title>
                                    <v-list-item-subtitle>
                                        <v-chip :color="getRoleColor(usuarioSelecionado.role)" size="small">
                                            {{ usuarioSelecionado.role }}
                                        </v-chip>
                                    </v-list-item-subtitle>
                                </v-list-item>
                            </v-list>
                        </v-col>

                        <!-- Status e Sessão -->
                        <v-col cols="12" md="6">
                            <h3 class="text-h6 mb-3 text-success">
                                <v-icon class="mr-2">mdi-information</v-icon>
                                Status da Sessão
                            </h3>
                            <v-list density="compact" class="bg-grey-lighten-5 rounded">
                                <v-list-item>
                                    <v-list-item-title class="font-weight-medium">Status Atual</v-list-item-title>
                                    <v-list-item-subtitle>
                                        <v-chip :color="getStatusColor(usuarioSelecionado.status)" size="small"
                                            variant="elevated">
                                            <v-icon start :icon="getStatusIcon(usuarioSelecionado.status)"
                                                size="14"></v-icon>
                                            {{ getStatusText(usuarioSelecionado.status) }}
                                        </v-chip>
                                    </v-list-item-subtitle>
                                </v-list-item>
                                <v-divider></v-divider>
                                <v-list-item>
                                    <v-list-item-title class="font-weight-medium">Último Acesso</v-list-item-title>
                                    <v-list-item-subtitle>
                                        <div v-if="usuarioSelecionado.ultimo_acesso">
                                            <div>{{ formatarData(usuarioSelecionado.ultimo_acesso) }}</div>
                                            <div class="text-caption text-grey">
                                                {{ formatarTempoRelativo(usuarioSelecionado.ultimo_acesso) }}
                                            </div>
                                        </div>
                                        <span v-else class="text-grey">Nunca</span>
                                    </v-list-item-subtitle>
                                </v-list-item>
                                <v-divider></v-divider>
                                <v-list-item>
                                    <v-list-item-title class="font-weight-medium">Total de Tokens</v-list-item-title>
                                    <v-list-item-subtitle>
                                        <v-chip color="info" size="small">
                                            {{ usuarioSelecionado.total_tokens }}
                                        </v-chip>
                                    </v-list-item-subtitle>
                                </v-list-item>
                                <v-divider></v-divider>
                                <v-list-item>
                                    <v-list-item-title class="font-weight-medium">Conta Ativa</v-list-item-title>
                                    <v-list-item-subtitle>
                                        <v-chip :color="usuarioSelecionado.ativo === 'Sim' ? 'success' : 'error'"
                                            size="small" variant="elevated">
                                            <v-icon start
                                                :icon="usuarioSelecionado.ativo === 'Sim' ? 'mdi-check-circle' : 'mdi-close-circle'"
                                                size="14"></v-icon>
                                            {{ usuarioSelecionado.ativo }}
                                        </v-chip>
                                    </v-list-item-subtitle>
                                </v-list-item>
                            </v-list>
                        </v-col>
                    </v-row>

                    <!-- Lista de Tokens -->
                    <v-divider class="my-6"></v-divider>
                    <h3 class="text-h6 mb-3 text-warning">
                        <v-icon class="mr-2">mdi-key-variant</v-icon>
                        Tokens Ativos ({{ usuarioSelecionado.tokens?.length || 0 }})
                    </h3>

                    <div v-if="usuarioSelecionado.tokens?.length > 0">
                        <v-row>
                            <v-col v-for="(tokenId, index) in usuarioSelecionado.tokens" :key="tokenId" cols="12" sm="6"
                                md="4">
                                <v-card variant="outlined" class="token-card">
                                    <v-card-text class="text-center pa-3">
                                        <v-icon color="primary" size="24" class="mb-2">mdi-key</v-icon>
                                        <div class="text-body-2 font-weight-bold">Token #{{ tokenId }}</div>
                                        <div class="text-caption text-grey">ID: {{ tokenId }}</div>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                    </div>
                    <v-alert v-else type="info" variant="tonal" density="compact">
                        Nenhum token ativo encontrado
                    </v-alert>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions class="pa-4">
                    <v-spacer></v-spacer>
                    <v-btn @click="modalDetalhes = false" variant="elevated" color="primary">
                        <v-icon start>mdi-check</v-icon>
                        Fechar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Snackbar para notificações -->
        <v-snackbar v-model="snackbar.show" :color="snackbar.color" :timeout="snackbar.timeout" location="top right">
            <div class="d-flex align-center">
                <v-icon class="mr-2">{{ snackbar.icon }}</v-icon>
                {{ snackbar.text }}
            </div>
            <template v-slot:actions>
                <v-btn variant="text" @click="snackbar.show = false">
                    Fechar
                </v-btn>
            </template>
        </v-snackbar>
    </v-container>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import { useUserStore } from '@/store/userStore'
import { useRouter } from 'vue-router' // ✅ ADICIONAR ESTA LINHA
import { adminTokenService } from '@/services/adminTokenService'

// ✅ INICIALIZAR O ROUTER
const router = useRouter()
const userStore = useUserStore()

// Estados
const usuariosLogados = ref([])
const estatisticas = ref(null)
const carregando = ref(false)
const navegando = ref(false) // ✅ ADICIONAR ESTA LINHA QUE ESTAVA FALTANDO
const revogando = ref(null)
const modalConfirmacao = ref(false)
const modalDetalhes = ref(false)
const usuarioSelecionado = ref(null)

// Snackbar
const snackbar = ref({
  show: false,
  text: '',
  color: 'success',
  icon: 'mdi-check',
  timeout: 4000
})

// Auto-refresh
let autoRefreshInterval = null

// Headers da tabela
const headers = [
  { title: 'Login', key: 'login', width: '120px' },
  { title: 'Nome', key: 'nome', sortable: true },
  { title: 'Email', key: 'email', sortable: true },
  { title: 'Role', key: 'role', width: '120px' },
  { title: 'Status', key: 'status', width: '140px' },
  { title: 'Último Acesso', key: 'ultimo_acesso', width: '180px' },
  { title: 'Tokens', key: 'total_tokens', width: '100px' },
  { title: 'Ativo', key: 'ativo', width: '80px' },
  { title: 'Ações', key: 'actions', width: '150px', sortable: false }
]

// 
const voltarMenuPrincipal = () => {
  navegando.value = true
  try {
    router.go(-1) // Volta para a página anterior (menu)
  } finally {
    setTimeout(() => {
      navegando.value = false
    }, 300)
  }
}

const atualizarDados = async () => {
  carregando.value = true
  try {
    const dados = await adminTokenService.buscarDadosCompletos()
    
    usuariosLogados.value = dados.usuarios
    estatisticas.value = dados.estatisticas

    mostrarNotificacao('Dados atualizados com sucesso!', 'success', 'mdi-check')

  } catch (error) {
    console.error('Erro:', error)
    mostrarNotificacao(
      error.message || 'Erro ao carregar dados', 
      'error', 
      'mdi-alert'
    )
  } finally {
    carregando.value = false
  }
}

const limparTokensExpirados = async () => {
  try {
    const response = await adminTokenService.limparTokensExpirados()
    mostrarNotificacao(response.message, 'success', 'mdi-check')
    await atualizarDados()
  } catch (error) {
    console.error('Erro:', error)
    mostrarNotificacao(
      error.message || 'Erro ao limpar tokens expirados', 
      'error', 
      'mdi-alert'
    )
  }
}

const revogarTodosTokens = (usuario) => {
  usuarioSelecionado.value = usuario
  modalConfirmacao.value = true
}

const confirmarRevogacao = async () => {
  revogando.value = usuarioSelecionado.value.id
  
  try {
    const response = await adminTokenService.revogarTodosTokensUsuario(usuarioSelecionado.value.login)
    
    mostrarNotificacao(response.message, 'success', 'mdi-check')
    await atualizarDados()
    
  } catch (error) {
    console.error('Erro:', error)
    mostrarNotificacao(
      error.message || 'Erro ao revogar tokens', 
      'error', 
      'mdi-alert'
    )
  } finally {
    revogando.value = null
    modalConfirmacao.value = false
    usuarioSelecionado.value = null
  }
}

const verDetalhes = (usuario) => {
  usuarioSelecionado.value = usuario
  modalDetalhes.value = true
}

const verDetalhesTokens = (usuario) => {
  verDetalhes(usuario)
}

const mostrarNotificacao = (texto, cor, icone) => {
  snackbar.value = {
    show: true,
    text: texto,
    color: cor,
    icon: icone,
    timeout: 4000
  }
}

// Funções de formatação
const formatarData = (data) => {
  return new Date(data).toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  })
}

const formatarTempoRelativo = (data) => {
  const agora = new Date()
  const dataAcesso = new Date(data)
  const diffMs = agora - dataAcesso
  const diffMinutos = Math.floor(diffMs / (1000 * 60))
  const diffHoras = Math.floor(diffMinutos / 60)
  const diffDias = Math.floor(diffHoras / 24)

  if (diffMinutos < 1) return 'Agora mesmo'
  if (diffMinutos < 60) return `${diffMinutos} min atrás`
  if (diffHoras < 24) return `${diffHoras}h atrás`
  return `${diffDias} dia${diffDias > 1 ? 's' : ''} atrás`
}

const getStatusColor = (status) => {
  switch (status) {
    case 'online': return 'success'
    case 'inativo': return 'warning'
    case 'offline': return 'error'
    default: return 'grey'
  }
}

const getStatusIcon = (status) => {
  switch (status) {
    case 'online': return 'mdi-circle'
    case 'inativo': return 'mdi-circle-outline'
    case 'offline': return 'mdi-circle-off-outline'
    default: return 'mdi-help-circle-outline'
  }
}

const getStatusText = (status) => {
  switch (status) {
    case 'online': return 'Online'
    case 'inativo': return 'Inativo'
    case 'offline': return 'Offline'
    case 'nunca_usado': return 'Nunca Usado'
    default: return 'Desconhecido'
  }
}

const getRoleColor = (role) => {
  switch (role?.toLowerCase()) {
    case 'admin':
    case 'administrador':
    case 'programador':
      return 'error'
    case 'supervisor':
    case 'gerente':
      return 'warning'
    case 'operador':
    case 'usuario':
      return 'info'
    default:
      return 'grey'
  }
}

// Lifecycle
onMounted(() => {
  atualizarDados()
  
  // Auto-refresh a cada 30 segundos
  autoRefreshInterval = setInterval(() => {
    if (!carregando.value) {
      atualizarDados()
    }
  }, 30000)
})

onUnmounted(() => {
  if (autoRefreshInterval) {
    clearInterval(autoRefreshInterval)
  }
})
</script>

<style scoped>
.stats-card {
    transition: all 0.3s ease;
    border-radius: 12px !important;
}

.stats-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15) !important;
}

.main-table-card {
    border-radius: 12px !important;
    overflow: hidden;
}

.confirmation-modal,
.details-modal {
    border-radius: 16px !important;
    overflow: hidden;
}

.token-card {
    transition: all 0.2s ease;
    border-radius: 8px !important;
}

.token-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.cursor-pointer {
    cursor: pointer;
}

.gap-2 {
    gap: 8px;
}

/* Animações */
@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(20px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.stats-card {
    animation: fadeInUp 0.6s ease;
}

.stats-card:nth-child(2) {
    animation-delay: 0.1s;
}

.stats-card:nth-child(3) {
    animation-delay: 0.2s;
}

.stats-card:nth-child(4) {
    animation-delay: 0.3s;
}

.main-table-card {
    animation: fadeInUp 0.6s ease 0.4s both;
}
</style>